import { useOutletContext } from 'react-router-dom';

import { Tabs, Tab } from '@shared/ui/tabs';
import { pushPermissions } from '@entities/marketing-push/lib';
import PushCampaignsTab from './tabs/PushCampaignsTab';
import { PushDevicesTab, PushTemplatesTab, PushTypesTab } from './tabs/PushSettingsTabs';
import type { User } from '../../types/interfaces';

/**
 * Раздел «Push-рассылки».
 *
 * Внешний layout — шапка, сайдбар, крошки — остаётся за ЛК: раздел живёт
 * внутри него и своих глобальных элементов не рисует.
 *
 * Вкладка «Типы уведомлений» показывается только тем, кто может их менять:
 * маркетологу справочник только для чтения, и отдельная вкладка ради этого
 * лишняя. Гейт здесь — про удобство, а не про защиту: те же права
 * проверяются на бэкенде при каждом запросе.
 */
export default function PushCampaigns() {
  const { me }: { me: User } = useOutletContext();
  const permissions = pushPermissions(me);

  return (
    <div className="p-4">
      <h1 className="mb-4 text-xl font-semibold text-[#2d2c2c]">Push-рассылки</h1>

      <Tabs variant="underline">
        <Tab title="Рассылки">
          <PushCampaignsTab permissions={permissions} />
        </Tab>
        <Tab title="Шаблоны">
          <PushTemplatesTab permissions={permissions} />
        </Tab>
        <Tab title="Тестовые устройства">
          <PushDevicesTab />
        </Tab>
        {permissions.manageTypes ? (
          <Tab title="Типы уведомлений">
            <PushTypesTab permissions={permissions} />
          </Tab>
        ) : (
          <></>
        )}
      </Tabs>
    </div>
  );
}
